import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Input, InputGroup, InputGroupAddon } from "reactstrap";

const InputWithLeftSelect = ({
  selectValue,
  onSelectChange,
  selectOptions,
  children,
  errorMessage = "",
  helpText = "",
  inputGroupClassName = "",
  selectClassName = "",
  selectAriaLabel = "Select option",
  selectMinWidth = "120px",
  selectStyle,
  stacked,
  selectLabel,
  selectDisabled,
}) => {
  if (stacked) {
    return (
      <div className="w-100 mb-2">
        <div className="form-group mb-2">
          <label className="mb-1 text-700 fs--1 font-weight-semi-bold">
            {selectLabel || "Moneda original"}
          </label>
          <Input
            type="select"
            aria-label={selectAriaLabel}
            value={selectValue}
            onChange={onSelectChange}
            disabled={selectDisabled}
            className={classNames("bg-light shadow-sm", selectClassName)}
            style={selectStyle}
          >
            {selectOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </div>
        <div className="form-group mb-0">
          {children}
        </div>
        {helpText ? <small className="text-700 d-block mt-1">{helpText}</small> : null}
        {errorMessage ? <small className="text-danger fs--1 d-block mt-1">{errorMessage}</small> : null}
      </div>
    );
  }

  return (
    <>
      <InputGroup className={classNames("shadow-sm", inputGroupClassName, {
        "border-danger": Boolean(errorMessage),
      })}>
        <InputGroupAddon addonType="prepend">
          <Input
            type="select"
            aria-label={selectAriaLabel}
            value={selectValue}
            onChange={onSelectChange}
            disabled={selectDisabled}
            className={classNames("bg-light border-right-0 font-weight-semi-bold text-700", selectClassName)}
            style={{ minWidth: selectMinWidth || "80px", width: "auto", ...selectStyle }}
          >
            {selectOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </InputGroupAddon>
        {children}
      </InputGroup>
      {helpText ? <small className="text-700 d-block mt-1">{helpText}</small> : null}
      {errorMessage ? <small className="text-danger fs--1 d-block mt-1">{errorMessage}</small> : null}
    </>
  );
};

InputWithLeftSelect.propTypes = {
  children: PropTypes.node.isRequired,
  selectValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSelectChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
  errorMessage: PropTypes.string,
  helpText: PropTypes.string,
  inputGroupClassName: PropTypes.string,
  selectClassName: PropTypes.string,
  selectAriaLabel: PropTypes.string,
  selectMinWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectDisabled: PropTypes.bool,
};


export default InputWithLeftSelect;